import { reactive, toRef } from 'vue';

const store = new Map();

export function useState(key, initialValue = null) {
    if (!store.has(key)) {
        store.set(key, reactive({ value: initialValue }));
    }
    const state = store.get(key);
    return toRef(state, 'value');
}

export function setState(key, value) {
    const state = store.get(key);
    if (state) {
        state.value = value;
    } else {
        const newState = reactive({ value });
        store.set(key, newState);
    }
}

export function getState(key, initialValue = undefined) {
    if (store.has(key)) {
        return store.get(key).value;
    }

    if (initialValue !== undefined) {
        setState(key, initialValue);
        return initialValue;
    }

    return undefined;
}

export function deleteState(key) {
    return store.delete(key);
}

export function clearState() {
    store.clear();
}
